import React from 'react'
import { cn } from '../../lib/utils'

interface OrangeSectionProps {
  children: React.ReactNode
  className?: string
}

/**
 * OrangeSection - A reusable component for orange background sections
 * 
 * This component provides the consistent orange background styling used throughout
 * the application for filter sections, search bars, and other grouped content areas.
 * 
 * Features:
 * - Exact orange color matching button colors (hsl(24.6 95% 53.1% / 0.1))
 * - Subtle border with matching orange color
 * - Backdrop blur effect for modern glass morphism
 * - Consistent padding and rounded corners
 * - Reusable across all pages
 * 
 * Usage:
 * <OrangeSection>
 *   <div>Your content here</div>
 * </OrangeSection>
 */
export function OrangeSection({ children, className }: OrangeSectionProps) {
  return (
    <div 
      className={cn(
        "p-6 rounded-lg border-4 border-orange-300 shadow-2xl shadow-orange-300/50 backdrop-blur-sm ring-2 ring-orange-200/20",
        className
      )}
      style={{ 
        backgroundColor: 'hsl(24.6 95% 53.1% / 0.1)', 
        borderColor: 'hsl(24.6 95% 53.1% / 0.3)' 
      }}
    >
      {children}
    </div>
  )
}
